import type AhaEditorV2Controller from '../../controllers/AhaEditorV2Controller';
import React from 'react';
import ToolbarMenuItem from './ToolbarMenuItem';
import { type ToolOrToolSet } from './types';
import { type Editor } from 'slate';

export const toolbarMenuKey = (tool: ToolOrToolSet): string => {
  if (Array.isArray(tool)) {
    return tool.map(toolbarMenuKey).join('-');
  } else {
    return tool.toolName;
  }
};

interface ToolbarMenuProps {
  editor: Editor;
  controller: AhaEditorV2Controller;
  toolOrArray: ToolOrToolSet;
}

const ToolbarMenu: React.FC<React.PropsWithChildren<ToolbarMenuProps>> = ({
  editor,
  controller,
  toolOrArray,
}) => {
  if (Array.isArray(toolOrArray)) {
    return (
      <aha-menu-group>
        {toolOrArray
          .filter((tool) => tool.available({ editor, controller }))
          .map((tool) => (
            <ToolbarMenu
              key={toolbarMenuKey(tool)}
              editor={editor}
              controller={controller}
              toolOrArray={tool}
            />
          ))}
      </aha-menu-group>
    );
  } else if (toolOrArray.available({ editor, controller })) {
    return (
      <ToolbarMenuItem
        editor={editor}
        controller={controller}
        tool={toolOrArray}
      />
    );
  } else {
    return null;
  }
};

export default ToolbarMenu;
